<div class="container appinfo">
    <div class="row m-0">
        <div class="main_content mt-2" pFocusTrap>
            <span class="text-lg-right float-lg-right">
                <button type="button" class="btnCancelSub" name="btncancelmySubmissionName" id="btncancelmySubmissionID"
                    [disabled]="indicationQG.isClearedSubmission" [class.notallowed]="indicationQG.isClearedSubmission"
                    (click)="cancelMySubmissionPopUp()" title="Cancel my Submission">
                    <i class="fa fa-times" aria-hidden="true"></i>
                    Cancel my Submission
                </button>
            </span>
            <form #applicationForm="ngForm" style="width:100%">
                <!-- Price Indication starts -->
                <div ngModelGroup="indication"  *ngIf="indicationQG.showPriceIndication">
                    <h3>Premium Indication</h3>               
                    <p-table class="table llh_table" [style]="{'margin-top': '20px'}"
                    [class.notallowed]="indicationQG.isClearedSubmission">
                        <ng-template pTemplate="header">
                            <tr>
                                <th rowspan="2" class="text-center" style="vertical-align: middle !important;font-size: 22px;">Coverages</th>
                                <th class="text-center" colspan="3" style="font-size: larger;">
                                      {{ indicationQG.hasAutoPhyDamage ? 'Available APD Deductible Options For Selection' : 'Premiums' }}
                                </th>
                            </tr>
                            <tr>
                                @if (indicationQG.userSelectedQuoteInVehicle === '0') {
                                    <th class="text-center" style="font-size: larger;">
                                        User Selected
                                    </th>
                                }
                                @if (indicationQG.hasAutoPhyDamage) {
                                    <th class="text-center" style="font-size: larger;">
                                        {{ indicationQG.userSelectedQuoteInVehicle === '1,000' ? 'User Selected - $ 1000' : 'Option - $ 1000' }}
                                    </th>
                                    <th class="text-center" style="font-size: larger;">
                                        {{ indicationQG.userSelectedQuoteInVehicle === '2,500' ? 'User Selected - $ 2500' : 'Option - $ 2500' }}
                                    </th>
                                }
                            </tr>
                            <!-- Auto Liability -->
                            <tr>
                                <td class="text-center">Auto Liability</td>
                                @if (indicationQG.userSelectedQuoteInVehicle === '0') {
                                    <td class="text-center">{{indicationQG.autoliabPremiumQAs[0]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoliabPremiumQAs[0]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                }
                                @if (indicationQG.hasAutoPhyDamage) {
                                    <td class="text-center">{{indicationQG.autoliabPremiumQAs[1]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoliabPremiumQAs[1]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                    <td class="text-center">{{indicationQG.autoliabPremiumQAs[2]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoliabPremiumQAs[2]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                }
                            </tr>
                            <!-- Auto Physical Damage -->
                            @if (indicationQG.hasAutoPhyDamage) {
                                <tr>
                                    <td class="text-center">Auto Physical Damage</td>
                                    @if (indicationQG.userSelectedQuoteInVehicle === '0') {
                                        <td class="text-center">{{indicationQG.autoPhyDamagePremiumQAs[0]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoPhyDamagePremiumQAs[0]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                    }                         
                                    <td class="text-center">{{indicationQG.autoPhyDamagePremiumQAs[1]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoPhyDamagePremiumQAs[1]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                    <td class="text-center">{{indicationQG.autoPhyDamagePremiumQAs[2]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoPhyDamagePremiumQAs[2]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                </tr>
                            }
                            <!-- Motor Truck Cargo -->
                            @if (indicationQG.isMTCIncluded) {
                                <tr>
                                    <td class="text-center">Motor Truck Cargo</td>
                                    @if (indicationQG.userSelectedQuoteInVehicle === '0') {
                                        <td class="text-center">
                                            {{ indicationQG.areCommoditiesEligible ?
                                                (indicationQG.mtcPremiumQAs[0]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' + 
                                                    (indicationQG.mtcPremiumQAs[0]?.maximum | currency:'USD' : 'symbol':'1.0-0') 
                                                : 'Not Included' }}
                                            @if (!indicationQG.areCommoditiesEligible) {
                                                <span style="color: red;">*</span>
                                            }
                                        </td>
                                    }                                    
                                    @if (indicationQG.hasAutoPhyDamage) {
                                        <td class="text-center">
                                            {{ indicationQG.areCommoditiesEligible ?
                                                (indicationQG.mtcPremiumQAs[1]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' +
                                                    (indicationQG.mtcPremiumQAs[1]?.maximum | currency:'USD' : 'symbol':'1.0-0')
                                                : 'Not Included' }}
                                            @if (!indicationQG.areCommoditiesEligible) {
                                                <span style="color: red;">*</span>
                                            }
                                        </td>
                                        <td class="text-center">
                                            {{ indicationQG.areCommoditiesEligible ? 
                                                (indicationQG.mtcPremiumQAs[2]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' +
                                                    (indicationQG.mtcPremiumQAs[2]?.maximum | currency:'USD' : 'symbol':'1.0-0')
                                                : 'Not Included' }}
                                            @if (!indicationQG.areCommoditiesEligible) {
                                                <span style="color: red;">*</span>
                                            }
                                        </td>
                                    }                                    
                                </tr>
                            }
                            <!-- General Liability -->
                            @if (indicationQG.isGlIncluded) {
                                <tr>
                                    <td class="text-center">General Liability</td>
                                    @if (indicationQG.userSelectedQuoteInVehicle === '0') {
                                        <td class="text-center">
                                            {{ indicationQG.hasGeneralLiabilityPremium ? 
                                                (indicationQG.generalLiablityPremium[0]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' +
                                                    (indicationQG.generalLiablityPremium[0]?.maximum | currency:'USD' : 'symbol':'1.0-0')
                                                : 'Not Included' 
                                            }}
                                        </td>
                                    }
                                    @if (indicationQG.hasAutoPhyDamage) {
                                        <td class="text-center">
                                            {{ indicationQG.hasGeneralLiabilityPremium ?
                                                (indicationQG.generalLiablityPremium[1]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' + 
                                                    (indicationQG.generalLiablityPremium[1]?.maximum | currency:'USD' : 'symbol':'1.0-0')
                                                : 'Not Included' 
                                            }}
                                        </td>
                                        <td class="text-center">
                                            {{ indicationQG.hasGeneralLiabilityPremium ?
                                                (indicationQG.generalLiablityPremium[2]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' + 
                                                    (indicationQG.generalLiablityPremium[2]?.maximum | currency:'USD' : 'symbol':'1.0-0')
                                                : 'Not Included' 
                                            }}
                                        </td>
                                    }                                    
                                </tr>
                            }
                            <!-- Estimated Account Premium -->
                            <tr>
                                <td class="text-center">Estimated Account Premium</td>
                                @if (indicationQG.userSelectedQuoteInVehicle === '0') {
                                    <td class="text-center"><b>{{indicationQG.totalPremiumQAs[0]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} -  {{indicationQG.totalPremiumQAs[0]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</b></td>
                                }
                                @if (indicationQG.hasAutoPhyDamage) {
                                    <td class="text-center"><b>{{indicationQG.totalPremiumQAs[1]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.totalPremiumQAs[1]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</b></td>
                                    <td class="text-center"><b>{{indicationQG.totalPremiumQAs[2]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.totalPremiumQAs[2]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</b></td>
                                }
                            </tr>
                            <!-- Select to Quote -->
                            @if (!!indicationQG.selectToQuote) {
                                <tr>
                                    <td class="text-center" >Select to Quote <span
                                        style="color: red;">*</span>
                                        <input type="hidden" name="selectToQuoteAnswer" #selectToQuoteAnswer="ngModel" [ngModel]="indicationQG.selectToQuote?.answer" required>
                                    </td>
                                    @if (indicationQG.userSelectedQuoteInVehicle === '0') {
                                        <td class="text-center">
                                            <p-checkbox name="selectToQuote" [binary]="true" [pAutoFocus]="true"
                                                [trueValue]="indicationQG.selectToQuote?.questionOptions[0]?.code" [falseValue]="''" 
                                                (onChange)="quoteSelected($event, indicationQG.selectToQuote?.questionOptions[0].code)"
                                                [(ngModel)]="indicationQG.selectToQuote.answer" [disabled]="indicationQG.isClearedSubmission"
                                                [class.invalid_div_cls]="!!applicationForm.submitted && selectToQuoteAnswer.invalid">
                                            </p-checkbox> 
                                        </td>
                                    }
                                    @if (indicationQG.hasAutoPhyDamage) {
                                        <td class="text-center">
                                            <p-checkbox name="selectToQuote" [binary]="true"
                                                [trueValue]="indicationQG.selectToQuote?.questionOptions[1]?.code" [falseValue]="''" 
                                                (onChange)="quoteSelected($event, indicationQG.selectToQuote?.questionOptions[1].code)" 
                                                [(ngModel)]="indicationQG.selectToQuote.answer" [disabled]="indicationQG.isClearedSubmission"
                                                [class.invalid_div_cls]="!!applicationForm.submitted && selectToQuoteAnswer.invalid"
                                                [pAutoFocus]="indicationQG.userSelectedQuoteInVehicle !== '0'">
                                            </p-checkbox>
                                        </td>
                                        <td class="text-center">
                                            <p-checkbox name="selectToQuote" [binary]="true" 
                                                [trueValue]="indicationQG.selectToQuote?.questionOptions[2]?.code" [falseValue]="''"  
                                                (onChange)="quoteSelected($event, indicationQG.selectToQuote?.questionOptions[2].code)"
                                                [(ngModel)]="indicationQG.selectToQuote.answer" [disabled]="indicationQG.isClearedSubmission"
                                                [class.invalid_div_cls]="!!applicationForm.submitted && selectToQuoteAnswer.invalid"> 
                                            </p-checkbox>
                                        </td>
                                    }
                                </tr>
                            }                            
                        </ng-template>
                    </p-table>

                    <div *ngIf="!indicationQG.areCommoditiesEligible && indicationQG.isMTCIncluded" style="color: rgb(170, 3, 3);margin-bottom: 15px;font-style: italic"><b>*Motor Truck Cargo indication is not included and will be reviewed by the underwriter upon submission.</b></div>
                    <div *ngIf="indicationQG.isGlIncluded && !indicationQG.hasGeneralLiabilityPremium" style="color: rgb(170, 3, 3);margin-bottom: 15px;font-style: italic"><b>*General Liability indication is not included and will be reviewed by the underwriter upon submission.</b></div>

                    <div style="font-style: italic; margin-bottom: 15px;">
                        <b>
                            The displayed pricing is a good faith estimate of the premium for the requested product based on our preliminary review of information currently available to us.
                            It is not an offer of insurance or a bindable quote.  Our underwriters will further review the application and may request additional information before a final quote can be delivered.
                        </b>
                    </div>
                    
                </div>
                <!-- Price Indication ends -->
                <div class="mt-4 clearfix"></div>     
                <h3 class="mt-2">Application Submission</h3>
                <div class="row mb-2">
                        <div class="col-lg-12" *ngIf="!!applicationInfoModel.applicationDetails">
                            <div class="row" *ngIf="displayIftaFileUpload">
                                <div class="col-md-6">
                                    <label name="lblfileUpload" id="lblfileUploadID" class="upload_label">Upload applicable for the following document</label>
                                    <ul>
                                        <li>
                                            IFTAs- four full quarters including the most recent
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <label>
                                        {{applicationInfoModel.applicationDetails?.iftaDocumentId?.questionLabel}}
                                        <span
                                            style="color: red;">{{applicationInfoModel.applicationDetails?.iftaDocumentId?.required
                                            ? '*' : ''}}</span>
                                    </label>
                                    <p-fileUpload #fileUpload name="demo2[]" id="demoID2[]" class="UploadCls iftaDocument"
                                        (onSelect)="onUpload($event)" (click)="clickUpload($event,'iftaDocument')"
                                        [accept]="fileNetAllowedFileExtensions" [multiple]="true" [auto]="true"
                                        [disabled]="indicationQG.isClearedSubmission"
                                        invalidFileTypeMessageSummary="{0}: Invalid file type." maxFileSize="15728640">
                                        <ng-template #content>
                                            <a (click)="fileUpload.choose()" name="iftafileUpload" id="iftafileUploadID" class="drag_and_drop"
                                                [class.notallowed]="indicationQG.isClearedSubmission"
                                                [class.fileUpload_error_cls]="(applicationForm.submitted || dao?.isSubmitForm) && !iftaDocsSatisfied">
                                                <h3 class="mb-0">
                                                    Drag & Drop Files Here
                                                </h3>
                                                <p class="mb-0">or</p>
                                                <h6>
                                                    Browse Files
                                                </h6>
                                            </a>
                                        </ng-template>
                                    </p-fileUpload>
                                    <div class="row filesrow" style="margin-top: 20px;"
                                        *ngFor="let item of applicationInfoModel.iftaDocumentFiles; let i= index;">
                                        <div class="col-lg-12">
                                            <div class="col-md-1 upload_file_icon">
                                                <i class="fa fa-file-o" style="margin-left: -2px;" aria-hidden="true"></i>
                                            </div>
                                            <div class="col-md-11 upload_file_details">
                                                <div class="upload_file_name">
                                                    {{item?.fileName}}
                                                </div>
                                                <span class="row text-right float-right upload_size_details"><b
                                                        class="color_dark">({{item?.filesize}})</b>
                                                    <i class="fa fa-times-circle-o ml-2 fa-lg color_green pointerCur" type="button"
                                                        [class.notallowed]="indicationQG.isClearedSubmission" 
                                                        title="Delete {{item?.fileName}}" (click)="deleteFile(item,i)"
                                                        aria-hidden="true" tabindex="0"
                                                        (keydown.space)="$event.preventDefault(); deleteFile(item,i)"></i>
                                                </span><br>
                                                <p-progressBar [value]="item?.progressValue"></p-progressBar>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mt-2">
                                        <div class="small color_grey">
                                            The combined file size limit is 15 MB.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2" style="padding: 0px 15px;">
                                <label name="lblquestionInfoText" id="questionInfoTextID"
                                    [class.validationred]="(applicationForm.submitted || dao?.isSubmitForm) && (applicationInfoModel.applicationDetails.motorCarrierFilingParent.answer == null || applicationInfoModel.applicationDetails.motorCarrierFilingParent.answer == '')">
                                    Are motor carrier filings needed for this account? If so, please list the filings needed
                                    <span
                                        style="color: red;">{{applicationInfoModel.applicationDetails?.motorCarrierFilingParent?.required
                                        ?
                                        '*' : ''}}</span>
                                </label>
                                <div class="" style="margin-left: 1%;">
                                    <div class="p-field-radiobutton">
                                        <p-radioButton name="motorCarrierFilingParent" id="motorCarrierFilingParentID"
                                            value="Y" class="radio_button" required inputId="Y"
                                            #motorCarrierFilingParent="ngModel" [disabled]="indicationQG.isClearedSubmission"
                                            [(ngModel)]="applicationInfoModel.applicationDetails.motorCarrierFilingParent.answer"
                                            [pAutoFocus]="!indicationQG.showPriceIndication">
                                        </p-radioButton>
                                        <label class="radio_button_lbl" name="lblMotorCarrierFilingParent"
                                            id="lblMotorCarrierFilingParentID">Yes</label>
                                        <p-radioButton name="motorCarrierFilingParent" id="motorCarrierFilingParentID"
                                            class="radio_button" value="N" required inputId="N"
                                            #motorCarrierFilingParent="ngModel"  [disabled]="indicationQG.isClearedSubmission"
                                            [(ngModel)]="applicationInfoModel.applicationDetails.motorCarrierFilingParent.answer">
                                        </p-radioButton>
                                        <label class="radio_button_lbl" name="lblMotorCarrierFilingParent"
                                            id="lblMotorCarrierFilingParentID">No</label>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-1" *ngIf="motorCarrierFilingParent.value == 'Y'">
                                <textarea class="form-control" rows="4" required
                                    [class.notallowed]="indicationQG.isClearedSubmission" 
                                    [(ngModel)]="applicationInfoModel.applicationDetails.motorCarrierFilingChild.answer"
                                    name="motorCarrierFilingChild" id="motorCarrierFilingChildID" type="text"></textarea>
                            </div>
                            <div class="mt-2">
                                <label class="" name="lblquestionInfoText" id="questionInfoTextID">
                                    Enter any notes you would like the Berkley Small Business Solutions Underwriter to
                                    consider below:
                                </label>
                            </div>
                            <div class="mt-1">
                                <textarea class="form-control" rows="4" 
                                    [(ngModel)]="applicationInfoModel.applicationDetails.underwriterNote.answer"
                                    name="underwriterNote" id="underwriterNote" type="text"
                                    [pAutoFocus]="indicationQG.isClearedSubmission"></textarea>
                            </div>
                            <div class="row mt-3 mb-3">
                                <div class="col-lg-12 text-center">
                                    <div class="col-lg-12 p-0 mt-3">
                                        <button type="button" class="btnerror float-left" title="Back"
                                            (click)="onBack('product')" [class.notallowed]="indicationQG.isClearedSubmission"
                                            [disabled]="indicationQG.isClearedSubmission">
                                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                                            Back
                                        </button>
                                        <span class="text-lg-right float-lg-right">
                                            <button type="submit" class="btnsuccess"
                                                (click)="saveAndContinue('OpenPdf')" title="View Application">
                                                <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                View Application
                                            </button>
                                            <button *ngIf="!indicationQG.showPriceIndication" type="submit" style="margin-left: 15px;"                
                                                class="btnsuccess" (click)="saveAndSubmit()" title="Save & Submit"
                                                data-toggle="modal">
                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                Save & Submit
                                            </button>
                                            <button *ngIf="indicationQG.showPriceIndication" type="submit" style="margin-left: 15px;"
                                                class="btnsuccess" [disabled]="indicationQG.isClearedSubmission"
                                                data-toggle="modal" (click)="clearMyAgency()" [class.notallowed]="indicationQG.isClearedSubmission" 
                                                pTooltip="Submission will be cleared under your agency and you must request a formal quote before 5 days of the policy effective date."
                                                tooltipStyleClass = "custom-tooltip-spacing"
                                                tooltipPosition="bottom">
                                                <i class="fa fa-registered" aria-hidden="true"></i>
                                                Clear My Agency
                                            </button>
                                            <button *ngIf="indicationQG.showPriceIndication" type="submit" style="margin-left: 15px;"
                                                class="btnsuccess"
                                                data-toggle="modal" (click)="requestQuoteAndSubmit()"
                                                pTooltip="Submission will be cleared under your agency, and a formal quote will be provided."
                                                tooltipStyleClass = "custom-tooltip-spacing"
                                                tooltipPosition="bottom">
                                                <i class="fa fa-handshake-o" aria-hidden="true"></i>
                                                Request Quote
                                            </button>
                                            <button type="submit" style="margin-left: 15px;" [disabled]="indicationQG.isClearedSubmission"
                                                class="btnsuccess" (click)="saveAndContinue('Draft')" [class.notallowed]="indicationQG.isClearedSubmission" 
                                                id="btnsaveContinueID" title="Save as Draft & Close" data-toggle="modal">
                                                <i class="fa fa-save" aria-hidden="true"></i>
                                                Save as Draft & Close
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
          </form>
        </div>
    </div>
</div>

<p-toast position="center" key="confirmation" class="validation_toast appinfoconfirm" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
            <div class="p-text-center" [innerHTML]="message?.data">
                {{message?.data}}
            </div>
            <div class="p-grid p-fluid mt-3">
                <div class="col-md-12 text-center validation_toast_btn" pFocusTrap>
                    <button type="button" pButton (click)="onReject('confirmation')" label="Ok"
                        class="p-button-success" [pAutoFocus]="true"></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-toast position="center" key="confirmModal" (onClose)="onReject('confirmModal')" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
          <div class="p-text-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
            <h4>{{ message.summary }}</h4>
            <h4 *ngIf="!!message.data.lossRunDocWarning">Minimum 3 years of loss runs will be required prior to binding the quote.</h4>
            <h4 *ngIf="!!message.data.iftaDocWarning">Most recent 4 full quarters IFTAs will be required prior to binding the quote.</h4>
          </div>
            <div class="p-grid p-fluid" pFocusTrap>
                <div class="p-col-6">
                    <button type="button" class="warnBtnSuccess float-right" title="Yes" name="btnSavePopUpYes"
                        id="btnSavePopYesID" (click)="confirmSave()">
                        <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                        Yes
                    </button>
                </div>
                <div class="p-col-6">
                    <button type="button" class="warnBtnerror" title="No" name="btnSavePopUpNo" id="btnSavePopNoID"
                        (click)="onReject('confirmModal')" [pAutoFocus]="true">
                        <i class="fa fa-thumbs-down" aria-hidden="true"></i>
                        No
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-toast position="center" key="c" (onClose)="onReject('c')" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
            <div class="p-text-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                <h4>{{message.summary}}</h4>
            </div>
            <div class="p-grid p-fluid" pFocusTrap>
                <div class="p-col-6">
                    <button type="button" name="btnDVCancelSubPopUpYes" id="btnDVCancelsubPopUpYesID" 
                        (click)="CancelmySubmission()" label="Yes" class="warnBtnSuccess float-right">
                    <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                     Yes
                    </button>
                </div>
                <div class="p-col-6">
                    <button type="button" name="btnDVCancelSubPopUpNo" id="btnDVCancelsubPopUpNoID"
                        (click)="onReject('c')" label="No" class="warnBtnerror" [pAutoFocus]="true">
                     <i class="fa fa-thumbs-down" aria-hidden="true"></i>                          
                     No
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-toast class="validation-toast" key="applicationToastKey" position="top-center"></p-toast>
<p-toast position="center" key="Delete" (onClose)="onReject('Delete')" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
            <div class="p-text-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                <h4>{{message.summary}}</h4>
            </div>
            <div class="p-grid p-fluid" pFocusTrap>
                <div class="p-col-6">
                    <button type="button" class="warnBtnSuccess float-right" title="Yes" name="btnLHPopUpYes"
                        id="btnLHPopYesID" (click)="confirmDelete()">
                        <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                        Yes
                    </button>
                </div>
                <div class="p-col-6">
                    <button type="button" class="warnBtnerror" title="No" name="btnLHPopUpNo" id="btnLHPopNoID"
                        (click)="onReject('Delete')" [pAutoFocus]="true">
                        <i class="fa fa-thumbs-down" aria-hidden="true"></i>
                        No
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
